module.exports = __webpack_public_path__ + "img/ico-yt.e27fe056.svg";